import type { RouteObject } from 'react-router-dom';
import AdminLayout from '../layouts/AdminLayout';
import QLSanPham from '../pages/admin/QLSanPham';
import QLTinTuc from '../pages/admin/QLTinTuc';
import NotFound from '../components/common/NotFound';
import Dashboard from '../pages/admin/Dashboard';
import QLQRSanpham from '../pages/admin/QLQRSanpham';
import QLKhachHang from '../pages/admin/QLKhachHang';
import QLThietBi from '../pages/admin/QLThietBi';
import QLTaiKhoan from '../pages/admin/QLTaiKhoan';
import DoiMatKhau from '../pages/admin/DoiMatKhau';

export const adminRoutes: RouteObject = {
  path: '/admin',
  element: <AdminLayout />,
  children: [
    { path: 'dashboard', element: <Dashboard /> },
    { path: 'products-management', element: <QLSanPham /> },
    { path: 'news-management', element: <QLTinTuc /> },
    { path: 'serials', element: <QLQRSanpham /> },
    { path: 'devices', element: <QLThietBi /> },
    { path: 'customers', element: <QLKhachHang /> },
    { path: 'accounts', element: <QLTaiKhoan /> },
    { path: 'change-password', element: <DoiMatKhau /> },
    { path: '*', element: <NotFound /> },
  ],
};